<p-confirmPopup></p-confirmPopup>
<div>
    <div class="flex flex-column">
        <p-table
        [value]="[selectedCourse]"
        dataKey="id"
        editMode="row"
        styleClass="p-datatable-gridlines p-datatable-striped">
            <ng-template pTemplate="caption">
                <div class="flex justify-content-between align-items-center">
                    <label class="font-bold text-xl">Curso: {{selectedCourse.title}}</label>
                    <div class="flex gap-2 align-items-center">
                        <p-tag
                            [value]="selectedCourse.isPublished ? 'Publicado' : 'Rascunho'"
                            [severity]="selectedCourse.isPublished ? 'success' : 'secondary'"
                            [rounded]="true"
                        ></p-tag>
                        <p-button
                            [label]="selectedCourse.isPublished ? 'Desativar' : 'Ativar'"
                            [icon]="selectedCourse.isPublished ? 'pi pi-lock' : 'pi pi-lock-open'"
                            [severity]="selectedCourse.isPublished ? 'danger' : 'success'"
                            (onClick)="ChangePublishedState()"
                        ></p-button>
                    </div>
                </div>
            </ng-template>

            <ng-template pTemplate="body" let-course let-editing="editing" let-ri="rowIndex">
                <tr [pEditableRow]="course">
                    <!-- Thumbnail -->
                    <td pTooltip="Thumbnail" style="width: 8rem">
                        <div class="md:w-8rem relative" style="cursor: pointer;" *ngIf="!editing && course.thumbnailUrl">
                            <img
                                (click)="openFileInput()"
                                class="block xl:block mx-auto border-round w-full"
                                [src]="course.thumbnailUrl"
                                [alt]="course.title"
                                (error)="onImageError($event)"
                            />
                        </div>

                        <div class="flex flex-column gap-2" *ngIf="editing || !course.thumbnailUrl">
                            <p-fileUpload
                                #buttonFileUpload
                                mode="basic"
                                name="thumbnail"
                                [multiple]="false"
                                [style]="{height:'2rem', wordBreak:'break-word', maxWidth:'25rem'}"
                                chooseIcon="pi pi-upload"
                                [disabled]="uploadingThumb"
                                accept="image/*"
                                maxFileSize="15000000"
                                (onSelect)="onFileSelectByHeader($event)"
                                invalidFileLimitMessageDetail="Limite: Máximo 15MB"
                                invalidFileLimitMessageSummary="Formato inválido!"
                            ></p-fileUpload>

                            <div class="flex gap-2 align-items-center" *ngIf="buttonFileUpload?.files?.length">
                                <p-tag [value]="buttonFileUpload.files[0].name" severity="info" [rounded]="true"></p-tag>
                                <p-button icon="pi pi-times" [text]="true" severity="danger" (onClick)="CancelArchive()" pTooltip="Cancelar"></p-button>
                                <p-button
                                    icon="pi pi-check"
                                    [text]="true"
                                    severity="success"
                                    (onClick)="uploadThumbnailWithService(course)"
                                    [loading]="uploadingThumb"
                                    pTooltip="Upload"
                                ></p-button>
                            </div>
                        </div>
                    </td>

                    <!-- Título -->
                    <td>
                        <div class="flex flex-column gap-2">
                            <label class="font-semibold text-lg">Título</label>
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input
                                        pInputText
                                        style="width: 100%;"
                                        type="text"
                                        [(ngModel)]="editTitle"
                                        placeholder="Título do curso"
                                    />
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{course.title}}
                                </ng-template>
                            </p-cellEditor>
                        </div>
                    </td>

                    <!-- Professor -->
                    <td>
                        <div class="flex flex-column gap-2">
                            <label class="font-semibold text-lg">Professor</label>
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <p-dropdown
                                        [options]="listTeachers"
                                        optionLabel="name"
                                        optionValue="id"
                                        [(ngModel)]="editTeacherId"
                                        placeholder="Selecione"
                                        appendTo="body"
                                        [style]="{ width: '100%' }"
                                    ></p-dropdown>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    <div class="flex align-items-center gap-2">
                                        <span *ngIf="course.teacher">{{course.teacher.name}}</span>
                                        <span *ngIf="!course.teacher" class="text-secondary">-</span>
                                    </div>
                                </ng-template>
                            </p-cellEditor>
                        </div>
                    </td>

                    <!-- Preço -->
                    <td>
                        <div class="flex flex-column gap-2">
                            <label class="font-semibold text-lg">Preço</label>
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <p-inputNumber
                                        [(ngModel)]="editPrice"
                                        locale="pt-BR"
                                        mode="currency"
                                        currency="BRL"
                                        placeholder="R$0,00"
                                    ></p-inputNumber>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{course.price | currency:'BRL':'symbol':'1.2-2'}}
                                </ng-template>
                            </p-cellEditor>
                        </div>
                    </td>

                    <!-- Público -->
                    <td>
                        <div class="flex flex-column gap-2">
                            <label class="font-semibold text-lg">Público</label>
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <p-selectButton
                                        [options]="isPublicOptions"
                                        [(ngModel)]="editIsPublic"
                                        optionLabel="label"
                                        optionValue="value"
                                    ></p-selectButton>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    <p-tag
                                        [value]="course.isPublic ? 'Sim' : 'Não'"
                                        [severity]="course.isPublic ? 'success' : 'warning'"
                                        [rounded]="true"
                                    ></p-tag>
                                </ng-template>
                            </p-cellEditor>
                        </div>
                    </td>

                    <!-- Descrição -->
                    <td>
                        <div class="flex flex-column gap-2">
                            <label class="font-semibold text-lg">Descrição</label>
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <textarea
                                        pInputTextarea
                                        rows="3"
                                        [(ngModel)]="editDescription"
                                        style="resize: none; width: 20vw;"
                                    ></textarea>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    <span class="text-sm text-600 line-height-3" style="max-width: 200px; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;">
                                        {{course.description}}
                                    </span>
                                </ng-template>
                            </p-cellEditor>
                        </div>
                    </td>

                    <!-- Ações -->
                    <td>
                        <div class="flex align-items-center justify-content-center gap-2">
                            <button
                                *ngIf="!editing"
                                pButton
                                pRipple
                                type="button"
                                pInitEditableRow
                                icon="pi pi-pencil"
                                (click)="onRowEditInit(course)"
                                class="p-button-rounded p-button-outlined"
                                pTooltip="Editar"
                            ></button>
                            <button
                                *ngIf="editing"
                                pButton
                                pRipple
                                type="button"
                                pSaveEditableRow
                                icon="pi pi-check"
                                (click)="onRowEditSave(course)"
                                class="p-button-rounded p-button-outlined p-button-success mr-2"
                                pTooltip="Salvar"
                            ></button>
                            <button
                                *ngIf="editing"
                                pButton
                                pRipple
                                type="button"
                                pCancelEditableRow
                                icon="pi pi-times"
                                (click)="onRowEditCancel(course, ri)"
                                class="p-button-rounded p-button-outlined p-button-danger"
                                pTooltip="Cancelar"
                            ></button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>

        <!-- Módulos -->
        <div class="card p-4" style="margin-top: 2rem;">
            <div class="flex justify-content-between align-items-center" style="margin-bottom: 1rem;">
                <label class="font-bold text-2xl">Módulos do Curso</label>
                <p-button
                    label="Novo Módulo"
                    icon="pi pi-plus"
                    (onClick)="createModule.toggle($event)"
                ></p-button>

                <p-overlayPanel #createModule>
                    <div class="flex justify-content-center align-items-center w-full" style="height: 20vh" *ngIf="addingModule">
                        <p-progressSpinner ariaLabel="loading" />
                    </div>

                    <div class="flex flex-column gap-3" *ngIf="!addingModule" style="min-width: 300px;">
                        <label class="font-semibold text-lg">Adicionar Novo Módulo</label>
                        <div class="flex flex-column" style="gap: 1.3rem;">
                            <p-floatLabel>
                                <input
                                    pInputText
                                    style="width: 100%;"
                                    type="text"
                                    [(ngModel)]="newModule.title"
                                    id="moduleTitle"
                                />
                                <label for="moduleTitle">Título do Módulo</label>
                            </p-floatLabel>
                            <p-floatLabel>
                                <textarea
                                    pInputTextarea
                                    rows="2"
                                    [(ngModel)]="newModule.description"
                                    style="resize: none; width: 100%;"
                                    id="moduleDesc"
                                ></textarea>
                                <label for="moduleDesc">Descrição (opcional)</label>
                            </p-floatLabel>
                        </div>
                        <div class="w-full flex justify-content-end gap-2">
                            <p-button
                                label="Cancelar"
                                severity="secondary"
                                [text]="true"
                                (onClick)="createModule.hide()"
                            ></p-button>
                            <p-button
                                label="Criar Módulo"
                                icon="pi pi-check"
                                (onClick)="AddModule($event)"
                            ></p-button>
                        </div>
                    </div>
                </p-overlayPanel>
            </div>

            <p-dataView #dv [value]="selectedCourse.courseModules" [layout]="layout">
                <ng-template let-module pTemplate="grid" let-modules>
                    <div class="grid grid-nogutter">
                        <div class="col-12 sm:col-4 md:col-4 xl:col-4 p-2" *ngFor="let module of modules">
                            <div
                                class="p-4 pt-2 border-1 surface-border surface-card border-round flex flex-column moduleCard"
                                style="cursor: pointer;"
                                (click)="ShowDialogModuleDetails(module)"
                            >
                                <div>
                                    <div class="flex gap-2 justify-content-between align-items-center">
                                        <p-tag
                                            [value]="'Ordem: ' + module.order"
                                            [style]="{ background: 'linear-gradient(to right, var(--surface-900), var(--surface-700))' }"
                                            [rounded]="true"
                                        />
                                        <p-button
                                            icon="pi pi-trash"
                                            severity="danger"
                                            text
                                            [disabled]="!module.id"
                                            (click)="ConfirmDeleteModule($event, module)"
                                            pTooltip="Excluir módulo"
                                        />
                                    </div>
                                    <div class="flex flex-row justify-content-between align-items-start gap-2 mt-2">
                                        <div>
                                            <div class="text-lg font-medium text-900">{{ module.title }}</div>
                                            <span class="font-medium text-secondary text-sm" *ngIf="module.description">
                                                {{ module.description }}
                                            </span>
                                            <span class="font-medium text-secondary text-sm" *ngIf="!module.description">
                                                Sem descrição
                                            </span>
                                        </div>
                                        <i class="pi pi-chevron-right text-400"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <ng-template pTemplate="empty">
                    <div class="flex flex-column align-items-center justify-content-center p-4">
                        <i class="pi pi-inbox text-4xl text-400 mb-2"></i>
                        <span class="text-600">Nenhum módulo encontrado</span>
                        <p-button
                            label="Criar primeiro módulo"
                            icon="pi pi-plus"
                            class="mt-2"
                            [link]="true"
                            (onClick)="createModule.toggle($event)"
                        ></p-button>
                    </div>
                </ng-template>
            </p-dataView>
        </div>
    </div>
</div>

<p-dialog
    header="Detalhes do Módulo"
    [draggable]="false"
    [closable]="true"
    [(visible)]="showDialogModuleDetails"
    [style]="{width:'60%', minHeight:'80%'}"
    [modal]="true"
    (onHide)="selectedModule=null"
>
    <app-module-details
        [selectedModule]="selectedModule!"
        (showPanel)="showDialogModuleDetails = $event"
        *ngIf="showDialogModuleDetails"
        (altered)="GetCourseModules()"
    ></app-module-details>
</p-dialog>
